export default __webpack_public_path__ + "static/media/market-gif4.d01f306f.gif";